import React, { useEffect, useState } from "react";
import { Parallax } from "react-scroll-parallax";

const Hero = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const getSpeed = (desktopSpeed) =>
    isMobile ? desktopSpeed * 0.35 : desktopSpeed * 1.4;

  return (
    <section
      className="relative min-h-screen flex flex-col items-center justify-center px-4 overflow-hidden scroll-mt-0 "
      style={{ scrollBehavior: "smooth" }}
    >
      {/* Top Right Ellipse Glow */}
      <Parallax speed={getSpeed(-18)} disabled={isMobile}>
        <div
          className="absolute pointer-events-none"
          style={{
            right: "-132vw",
            top: "-83vh",
            width: "97vw",
            height: "97vh",
            background: "#06B6D4",
            borderRadius: "50%",
            filter: isMobile ? "blur(110px)" : "blur(150px)",
            opacity: 0.6,
            transform: "scale(1.02)",
          }}
        />
      </Parallax>

      {/* Noise Overlay */}

      <div
        className="absolute pointer-events-none"
        style={{
          inset: 0,
          width: "100%",
          height: "100%",
          backgroundImage: "url(/images/noise.svg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          opacity: 0.58,
          mixBlendMode: "overlay",
        }}
      />

      {/* Gradient Overlay */}
      <div className="absolute inset-0 gradient-overlay pointer-events-none" />

      <div className="relative z-10 text-center max-w-4xl mx-auto w-full">
        {/* Logo */}
        <Parallax speed={getSpeed(14)}>
          <div
            className="flex items-center justify-center mx-auto"
            style={{
              width: "clamp(300px, 50vw, 726px)",
              height: "clamp(43px, 7.3vw, 105px)",
              marginBottom: "clamp(2rem, 5vh, 3.75rem)",
            }}
          >
            <img
              src="/images/logo.svg"
              alt="Heyareweare Technologies"
              className="w-full h-auto max-h-full object-contain"
            />
          </div>
        </Parallax>

        {/* Tagline */}
        <Parallax speed={getSpeed(20)}>
          <h2
            className="mx-auto block leading-tight tracking-[0.13em] font-montserrat bg-gradient-to-r from-[#009999] to-[#ffffff] text-transparent bg-clip-text"
            style={{
              fontSize: isMobile
                ? "clamp(-0.25rem, 3.5vw, 1.1rem)"
                : "clamp(1.125rem, 2.5vw, 1.75rem)",
              lineHeight: isMobile
                ? "clamp(1rem, 2.5vw, 1.3rem)"
                : "clamp(1.375rem, 3vw, 1.7rem)",
              width: "100%",
              marginBottom: "clamp(2rem, 5vh, 3.75rem)",
              whiteSpace: isMobile ? "nowrap" : "normal",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            SEE THE WORLD IN A WHOLE NEW WAY
          </h2>
        </Parallax>

        {/* CTA Button */}
        <Parallax speed={getSpeed(16)}>
          <button
            onClick={() => {
              const footer = document.querySelector("footer");
              footer?.scrollIntoView({ behavior: "smooth" });
            }}
            className="bg-white font-montserrat text-black rounded-full font-medium hover:bg-gray-100 transition-all duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 mx-auto block"
            style={{
              width: "clamp(9.375rem, 20vw, 14.375rem)",
              height: "clamp(2.5rem, 5.5vh, 3.375rem)",
              fontSize: "clamp(0.875rem, 1.8vw, 1rem)",
              borderRadius: "3.125rem",
            }}
          >
            Let's Connect
          </button>
        </Parallax>
      </div>
    </section>
  );
};

export default Hero;
